<template>
  <footer>
    <div class="company">
      <img src="../assets/img/website_logo.png" alt="Company logo">
      <div class="company__icons">
        <div class="company__icons__payment">
          <img src="../assets/img/icons/visa.png" alt="VISA">
          <img src="../assets/img/icons/mastercard.png" alt="MasterCard">
        </div>
        <div class="company__icons__social">
          <a target="_blank" href="https://www.facebook.com/JadalniawMiedzylesiu/">
            <img src="../assets/img/icons/facebook.png" alt="Facebook">
          </a>
        </div>
      </div>
    </div>
    <div class="text_content">
      <p>Copyright &copy; Jadalnia 2019</p>
      <p>Made with <span class="heart">♥</span> by SpaceView</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
  footer {
    background: #ed7924;

    .company {
      padding: 20px;
      display: flex;
      justify-content: space-between;

      img {
        height: 50px;
      }
      &__icons {
        display: flex;
        justify-content: space-between;
        img {
          cursor: pointer;
        }
      }
    }
    .text_content {
      padding: 10px;
      background: #010101;
      text-align: center;
      color: white;

      p {
        margin: 0;

        .heart {
          color: firebrick;
        }
      }
    }
  }
</style>
